<template>
  <div>
    <!-- <GmapMap /> -->
    <Leaflet v-if="$route.path.includes('alert-ex-post')" />
    <Map v-else />
  </div>
</template>

<script>

import Map from '@/components/core/Map.vue';

export default {
  components: {
    Map,
    Leaflet: () => import('@/components/core/Leaflet')
  }
};
</script>
